// extracted by mini-css-extract-plugin
module.exports = {"label":"styles__label___1w33M","checkbox":"styles__checkbox___1m9B1"};